import React, { createContext, useContext, useState, useEffect } from "react";
import Axios from "axios";

const CustomerContext = createContext();

export const CustomerProvider = ({ children }) => {
  const [customers, setCustomers] = useState([]);
  const [isFetching, setIsFetching] = useState(false);

  // 🔄 جلب كل الزبائن
  const fetchCustomers = async () => {
    try {
      setIsFetching(true);
      const res = await Axios.get(
        `${process.env.REACT_APP_API_URL}/customer/getCustomers.php`
      );
      if (res.data.status === "success") {
        setCustomers(res.data.customers || []);
      } else {
        console.error("⚠️ فشل في جلب البيانات:", res.data.message);
      }
    } catch (err) {
      console.error("❌ فشل في جلب الزبائن:", err);
    } finally {
      setIsFetching(false);
    }
  };

  // ✏️ تحديث زبون
  const updateCustomer = async (customerData) => {
    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_API_URL}/customer/updateCustomer.php?id=${customerData.id}`,
        customerData
      );

      if (res.data.status === "success") {
        // 🔥 حدث الزبون مباشرة في الحالة بدون إعادة تحميل الصفحة
        setCustomers((prev) =>
          prev.map((customer) =>
            customer.id === customerData.id ? res.data.customer : customer
          )
        );
        return { success: true, message: res.data.message };
      } else {
        return { success: false, message: res.data.message };
      }
    } catch (err) {
      console.error("❌ خطأ أثناء تحديث الزبون:", err);
      return {
        success: false,
        message: err.response?.data?.message || "حدث خطأ أثناء التحديث",
      };
    }
  };

  // 📋 جلب بيانات زبون واحد مع فواتيره
  const getCustomerProfile = async (id) => {
    try {
      const res = await Axios.get(
        `${process.env.REACT_APP_API_URL}/customer/getCustomerProfile.php?id=${id}`
      );
      if (res.data.status === "success") {
        return res.data;
      } else {
        throw new Error(res.data.message);
      }
    } catch (err) {
      console.error("❌ خطأ أثناء جلب بيانات الزبون:", err);
      throw err;
    }
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  return (
    <CustomerContext.Provider
      value={{
        customers,
        setCustomers,
        isFetching,
        fetchCustomers,
        updateCustomer,
        getCustomerProfile,
      }}
    >
      {children}
    </CustomerContext.Provider>
  );
};

// ✅ هوك مخصص للاستخدام السهل
export const useCustomerContext = () => useContext(CustomerContext);
